module.exports = __webpack_public_path__ + "img/logo_rgb.aeaf3443.png";